document.documentElement.classList.add("js");

document.addEventListener("DOMContentLoaded", function () {

  /* -----------------------------
     Fade-in on scroll (Finishes)
  ------------------------------ */
  function initFade() {
    const elements = document.querySelectorAll(
      ".spacrete-page--finishes .spacrete-hero, \
       .spacrete-page--finishes .spacrete-text, \
       .spacrete-page--finishes .spacrete-split, \
       .spacrete-page--finishes .spacrete-full-image, \
       .spacrete-page--finishes .spacrete-color-grid, \
       .spacrete-page--finishes .spacrete-faq, \
       .spacrete-page--finishes .spacrete-callout, \
       .spacrete-page--finishes .spacrete-heading-only, \
       .spacrete-page--finishes .spc-lux, \
       .spacrete-page--finishes .spc-hsc"
    );

    if (!elements.length) return;

    // If IO is not available, reveal all immediately
    if (!("IntersectionObserver" in window)) {
      elements.forEach(el => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: "0px 0px -10% 0px"
    });

    elements.forEach(el => {
      // Prevent re-observing / re-animating in theme editor
      if (el.classList.contains("is-visible")) return;
      if (el.dataset.spcFadeInit === "1") return;
      el.dataset.spcFadeInit = "1";
      observer.observe(el);
    });
  }

  initFade();

  document.addEventListener("shopify:section:load", function () {
    // Re-scan the full document (wrapper exists outside section scope)
    initFade();
  });

  /* -----------------------------
     Lux Collapsible (your code)
  ------------------------------ */
  (function () {

    function px(n) {
      return Math.max(0, Math.round(n));
    }

    function measureLineHeight(el) {
      var lh = window.getComputedStyle(el).lineHeight;

      if (lh === 'normal') {
        var fs = parseFloat(window.getComputedStyle(el).fontSize || '16');
        return fs * 1.2;
      }

      return parseFloat(lh);
    }

    function setClamp(root) {

      var inner = root.querySelector('.spc-lux__inner');
      var panel = root.querySelector('.spc-lux__panel');
      var btn = root.querySelector('.spc-lux__btn');

      if (!inner || !panel || !btn) return;

      var lines = parseInt(root.getAttribute('data-ln') || '4', 10);
      if (!isFinite(lines) || lines < 2) lines = 4;

      var lineH = measureLineHeight(inner);
      var collapsedH = px(lines * lineH);

      var prevMax = panel.style.maxHeight;
      panel.style.maxHeight = 'none';

      var fullH = px(panel.scrollHeight);

      panel.style.maxHeight = prevMax;

      if (fullH <= collapsedH + 2) {

        panel.style.maxHeight = 'none';
        btn.style.display = 'none';

        root.classList.add('is-short');
        return;

      } else {

        btn.style.display = '';
        root.classList.remove('is-short');

      }

      if (root.classList.contains('is-open')) {
        panel.style.maxHeight = fullH + 'px';
      } else {
        panel.style.maxHeight = collapsedH + 'px';
      }

    }

    function syncBtn(root) {

      var btn = root.querySelector('.spc-lux__btn');
      var btnText = root.querySelector('.spc-lux__btntext');

      if (!btn || !btnText) return;

      var more = btnText.getAttribute('data-more') || 'Read more';
      var less = btnText.getAttribute('data-less') || 'Read less';

      var open = root.classList.contains('is-open');

      btn.setAttribute('aria-expanded', open ? 'true' : 'false');

      btnText.textContent = open ? less : more;

    }

    function initOne(root) {

      if (root.__luxInit) return;
      root.__luxInit = true;

      var btn = root.querySelector('.spc-lux__btn');
      var panel = root.querySelector('.spc-lux__panel');

      if (!btn || !panel) return;

      var openByDefault = root.getAttribute('data-opn') === '1';
      if (openByDefault) root.classList.add('is-open');

      function recalc() {
        setClamp(root);
        syncBtn(root);
      }

      btn.addEventListener('click', function () {
        root.classList.toggle('is-open');
        recalc();
      });

      recalc();

      var resizeT;

      window.addEventListener('resize', function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(recalc, 120);
      });

    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-luxcol]');
      roots.forEach(initOne);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

  })();

});